<template>
    <div class="Page" v-if="State">
        <Header Act="8"></Header>
        <div class="MaxWid">
            <div class="MarTop">
                <div class="AboutPos" @click="Back">当前位置：公示信息</div>
            </div>
            <div class="Cont" v-if="Data">
                <div class="title">{{Data.name || Data.title}}</div>
                <div class="ContDis">
                    <div class="Flex">发布时间：{{formatTime(Data.updatetime || Data.createtime)}}</div>
                    <div class="Flex" v-if="Data.status_text">状态：{{Data.status_text}}</div>
                </div>
                <div class="ContHead" v-html="Data.content || Data.synopsis"></div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/header/head';
    import Footer from '@/components/header/footer';
    export default {
        components: {Header,Footer},
        data() {
            return {
                Data:"",
                State:"",
            }
        },
        mounted() {
            // 从路由参数读取，根据id和type从API获取数据
            const routeType = this.$route.query.type;
            const routeId = this.$route.query.id;
            
            if (routeType && routeId) {
                // 有路由参数，根据type和id从API获取数据
                this.State = routeType;
                this.fetchDetailById(routeId, routeType);
            } else {
                // 没有路由参数，显示错误提示
                this.$message.error("缺少必要的参数，无法获取详情数据");
            }
        },
        methods: {
            // 根据id和type从API获取详情数据
            fetchDetailById(id, type) {
                let requestPromise;
                
                if (type == 7) {
                    // 伦理公示使用 occupation 接口，需要先获取 category_id=1 的数据
                    requestPromise = this.$post('api/index/occupation', {
                        category_id: 1,
                        page: 1,
                        limit: 1000
                    });
                } else {
                    // 信息公示使用 registerList 接口
                    requestPromise = this.$post('api/index/registerList', {
                        limit: 1000
                    });
                }
                
                requestPromise.then(res => {
                    if (res.data && res.data.code == 1) {
                        const list = res.data.data.data || res.data.data || [];
                        // 从列表中找到对应id的数据
                        const detail = list.find(item => String(item.id) === String(id));
                        if (detail) {
                            // 处理数据字段，确保兼容性
                            const info = { ...detail };
                            if (!info.name && info.title) {
                                info.name = info.title;
                            }
                            if (!info.updatetime && info.createtime) {
                                info.updatetime = info.createtime;
                            }
                            this.Data = info;
                        } else {
                            // 如果API中找不到对应id的数据
                            this.$message.error("未找到对应的详情数据");
                        }
                    } else {
                        // API请求失败
                        this.$message.error((res.data && res.data.msg) || "获取详情数据失败");
                    }
                }).catch(err => {
                    console.error("获取详情失败", err);
                    this.$message.error("获取详情数据失败，请稍后重试");
                });
            },
            Back(){
                this.$router.go(-1)
            },
            formatTime(timestamp) {
                if (!timestamp) return '';
                // 将秒级时间戳转换为毫秒级
                const date = new Date(timestamp * 1000);
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            }
        },
    }
</script>
<style scoped>
    .Page {
        background: #fff;
    }
    
    .BgColorBlue {
        background-color: #037dbe;
    }
    
    .BgColorYellow {
        background-color: #ed8404;
    }
    
    .BgColorGreen {
        background-color: #82ae1d;
    }
    
    .MarTop {
        margin-top: 20px;
    }
    .MaxWid {
        max-width: 1180px;
        padding: 0 10px;
        margin: 0 auto;
    }
    .AboutPos{
        padding: 20px 0;
        font-size: 12px;
        color: #999999;
        cursor: pointer;
    }
    .title{
        padding: 20px 0;
        text-align: center;
        font-size: 18px;
    }
    .ContDis{
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom: 1px solid #ddd;
    }
    .ContDis .Flex{
        width: 30%;
        font-size: 14px;
        color: #666;
        padding-bottom:20px;
        text-align: center;
    }
    .ContHead{
        margin: 20px 0;
        width: 100%;
    }
</style>

